import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    CartesianGrid,
    ResponsiveContainer,
    Label,
    LabelList,
} from 'recharts';
const HistoryBarChart = ({ chartData, authors, yAxisLabel }) => {
    const [visibleAuthors, setVisibleAuthors] = useState([]);
    useEffect(() => {
        setVisibleAuthors(
            Object.fromEntries(authors.map(author => [author, true]))
        );
    }, [authors]);
    const handleLegendClick = (event) => {
        const { value } = event;
        setVisibleAuthors(prev => ({
            ...prev,
            [value]: !prev[value], // Toggle visibility
        }));
    };
    // Custom formatter to hide labels for small values
    const renderLabel = (value) => {
        return value >= 3 ? value : '';
    };
    return (
        <div style={{ overflowX: 'auto' }}>
            <div style={{ width: `${chartData.length * 50}px`, minWidth: '100%' }}>
                <ResponsiveContainer width="100%" height={500}>
                    <BarChart
                        data={chartData}
                        margin={{ top: 20, right: 30, left: 20, bottom: 80 }} // increase bottom margin
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                            dataKey="date"
                            type="category"
                            tick={{ angle: 90, dx: 10, dy: 50 }}
                            interval={0}
                        >
                            <Label value="Dates" position="insideBottom" offset={-1} fontWeight='bold' />
                        </XAxis>
                        <YAxis>
                            <Label
                                style={{
                                    textAnchor: 'middle',
                                    fontSize: '100%',
                                    fill: 'black',
                                }}
                                angle={270}
                                position="centerBottom"
                                value={yAxisLabel}
                                dx={-10}
                            />
                        </YAxis>
                        <Tooltip />
                        <Legend
                            onClick={handleLegendClick}
                            payload={authors.map((author, index) => ({
                                value: author,
                                type: 'line',
                                color: `hsl(${index * 30},70%,50%)`,
                                inactive: !visibleAuthors[author],
                            }))}
                            verticalAlign="top"
                            height={36}
                        />
                        {authors.map((author, index) =>
                            visibleAuthors[author] ? (
                                <Bar
                                    key={author}
                                    dataKey={author}
                                    stackId="a"
                                    fill={`hsl(${index * 30}, 70%, 50%)`}
                                    barSize={40}
                                >
                                    <LabelList
                                        dataKey={author}
                                        position="insideTop"
                                        fill="#fff"
                                        fontSize={15}
                                        formatter={renderLabel}
                                    />
                                </Bar>
                            ) : null
                        )}
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

// PropTypes validation
HistoryBarChart.propTypes = {
    chartData: PropTypes.array.isRequired,
    authors: PropTypes.array.isRequired,
    yAxisLabel: PropTypes.string.isRequired,
};
export default HistoryBarChart;